import ready from './ready';
import { getScore, getScoreArray } from './scores';
import Cookies from 'js-cookie';

const visibleClass = '-form-visible';

function gtmSubmitEvent() {
	window.dataLayer =  window.dataLayer || [];
	window.dataLayer.push({
		event: 'generate_lead',
	});
}

/**
 * Get the column that holds the form
 * @returns {HTMLElement}
 */
function getColumn() {
	return document.querySelector('.quiz__list-radar');
}

/**
 * Reveal the form in its column
 * @param {HTMLElement} column The column element
 */
async function showForm(column) {
	// make the form visible
	document.body.classList.add(visibleClass);
	column.classList.add(visibleClass);
	column.classList.add('-is-disabled');

	// Fetch the results link in the background
	const link = await getResultsLink();
	window.ORBITER = window.ORBITER || {};
	window.ORBITER.resultsLink = link;
	window.ORBITER.intro = getIntroAnswers();
	document.body.dispatchEvent(new CustomEvent('results-link-ready'));
	column.classList.remove('-is-disabled');
}

/**
 * @returns {HTMLElement} The tease holder
 */
function getTease() {
	return document.querySelector('.submit-form__tease');
}

/**
 * Wrap an element so it can be used as position fixed
 *
 * @param {HTMLElement} toWrap Element to be wrapped
 * @returns {HTMLElement}
 */
function createPlaceholder(toWrap) {
	const holder = document.createElement('div');
	const height = toWrap.getBoundingClientRect().height;
	holder.style.height = height + 'px';
	toWrap.parentElement.insertBefore(holder, toWrap);
	holder.appendChild(toWrap);
	return holder;
}

/**
 * Hide the form in its column
 * @param {HTMLElement} column The column element
 */
function hideForm(column) {
	document.body.classList.remove(visibleClass);
	column.classList.remove(visibleClass);
}

function onSubmit(event) {
	if (!event.target.matches('.-last-question')) {
		return;
	}
	showForm(getColumn());

	const tease = getTease();
	const wrapper = createPlaceholder(tease);

	function onScroll() {
		const rect = wrapper.getBoundingClientRect();

		if (rect.top > window.innerHeight - rect.height) {
			tease.classList.add('-float');
		} else {
			tease.classList.remove('-float');
			wrapper.style.height = 'auto';
			window.removeEventListener('scroll', onScroll);
		}
	}

	onScroll();
	window.addEventListener('scroll', onScroll);

	event.preventDefault();
}

function onReset(event) {
	hideForm(getColumn());
	event.preventDefault();
}

/**
 * Get the answers to the intro question as a plain object
 * @returns {Object}
 */
function getIntroAnswers() {
	const answers = {};
	const form = document.getElementById('introform');
	const selects = form.querySelectorAll('select');

	Array.prototype.forEach.call(selects, (el) => {
		answers[el.name] = el.value;
	});
	return answers;
}

function onClick(e) {
	const mquery = window.matchMedia('(min-width: 768px');
	if (mquery.matches === false) {
		const y = window.scrollY;
		const offset =
			e.currentTarget.parentElement.parentElement.getBoundingClientRect().top;

		try {
			window.scrollTo({ top: y + offset, left: 0, behavior: 'smooth' });
		} catch (e) {
			window.scrollTo(0, y + offset);
		}
	}
}

/**
 * Set a form asa loading or not
 *
 * @param {HTMLElement} el The element to set as loading (a form)
 * @param {boolean} isLoading whether it's loading
 */
function isLoading(el, isLoading) {
	if (isLoading) {
		el.classList.add('-is-loading');
	} else {
		el.classList.remove('-is-loading');
	}
}

/**
 * Show a message related to the form
 *
 * @param {string} message The message to show
 * @param {HTMLFormElement} form The form affected
 */
function showFormMessage(message, form) {
	function onTransitionEnd(event) {
		event.target.style.height = 'auto';
		event.target.removeEventListener('transitionend', onTransitionEnd);
	}

	const msgHolder = form.querySelector('.submit-form__response');
	msgHolder.parentElement.addEventListener('transitionend', onTransitionEnd);

	if (message === false) {
		msgHolder.innerHTML = '';
		msgHolder.parentElement.style.height = '0';
	} else {
		msgHolder.innerHTML = message;
		msgHolder.parentElement.style.height = msgHolder.scrollHeight + 'px';
	}
}

/**
 * @param {string} cookieKey The cookie key
 * @returns {string} The value of the cookie, or an empty string
 */
function getCookieVal(cookieKey) {
	let val = Cookies.get(cookieKey);
	if (typeof val === 'undefined') {
		val = '';
	}
	return val;
}

function mainSubmit(event) {
	const action = event.target.getAttribute('action');
	// collect the quiz answers
	const scoreArray = getScoreArray();
	// collect the intro answers
	const intro = getIntroAnswers();
	// combine with this form's answers
	const formData = new FormData(event.target);
	// Add answers to form
	scoreArray.forEach((el, index) => {
		if (el.type === 'valueslider') {
			formData.append('q' + index, el.answer);
		} else {
			formData.append('q' + index, el.answerid);
		}
	});

	// add intro answers to form
	for (let key in intro) {
		if (Object.prototype.hasOwnProperty.call(intro, key)) {
			formData.append(key, intro[key]);
		}
	}

	// add final score to form
	const rating = getScore(scoreArray);
	formData.append('rating', rating);

	// get tracker values
	formData.append('utm_medium', getCookieVal('utm_medium'));
	formData.append('utm_content', getCookieVal('utm_content'));
	formData.append('utm_campaign', getCookieVal('utm_campaign'));
	formData.append('utm_source', getCookieVal('utm_source'));

	isLoading(event.target, true);
	showFormMessage('', event.target);

	// send the form data
	fetch(action, {
		method: 'POST',
		body: formData,
	})
		.then(
			// resolve i.e. successful network request (regardless of http status)
			(response) => {
				return response.json().catch(() => {
					// A problen deciphering the server's response
					throw new Error(
						'Sorry there was a problem submitting your message, please try again.'
					);
				});
			},

			// reject, i.e. failed network request
			() => {
				throw new Error(
					'Sorry, we could not submit the form. Please try again.'
				);
			}
		)
		.then((data) => {
			if (data.state === 'error') {
				throw new Error(data.message);
			}
			//console.dir(JSON.parse(data.message));
			// success
			const submitButton = event.target.querySelector('[type="submit"]');
			submitButton.setAttribute('disabled', 'disabled');
			event.target.classList.add('-submit-success');
			showFormMessage(data.message, event.target);
			gtmSubmitEvent();
		})
		.catch((e) => {
			showFormMessage(e.message, event.target);
			console.error(e.message);
		})
		.finally(() => {
			isLoading(event.target, false);
		});

	event.preventDefault();
}

function prepareFormData() {
	const scoreArray = getScoreArray();
	const rating = getScore(scoreArray);
	const intro = getIntroAnswers();
	const formData = new FormData();

	// Add answers to form
	scoreArray.forEach((el, index) => {
		if (el.type === 'valueslider') {
			formData.append('q' + index, el.answer);
		} else {
			formData.append('q' + index, el.answerid);
		}
	});

	// add intro answers to form
	for (let key in intro) {
		if (Object.prototype.hasOwnProperty.call(intro, key)) {
			formData.append(key, intro[key]);
		}
	}

	formData.append('rating', rating);
	return formData;
}

async function getResultsLink() {
	const submissionForm = document.getElementById('submissionform');
	const action = submissionForm.getAttribute('action');
	const formData = prepareFormData();

	try {
		const response = await fetch(action, {
			method: 'POST',
			body: formData,
		});

		const data = await response.json();

		if (data.state !== 'ok') {
			throw new Error(data.message);
		} else {
			return data.link;
		}
	} catch (e) {
		console.error(e.message);
	} finally {
		// enable form
	}
}

ready.then(() => {
	document.body.addEventListener('submit', onSubmit);
	document.body.addEventListener('reset.bouygues', onReset);

	getTease().addEventListener('click', onClick);

	// document
	// 	.getElementById('submissionform')
	// 	.addEventListener('submit', mainSubmit);
});
